import React from "react";

// Lockup di brand JOBTIMEHR: icona (clessidra/orologio con spunta) + wordmark testuale
// sempre leggibile ("JOB" + "TIME" arancio + "HR"). Scala con il font-size del contesto (em).
// Su sfondo scuro l'icona usa la variante bianca (parti blu -> bianche), su chiaro quella a colori.
const LOGO_WHITE = "/brand/jobtimehr_white.png?v=2";
const LOGO_NAVY = "/brand/jobtimehr_navy.png?v=2";
const NAVY = "#16345c";
const ORANGE = "#ff7e00";

export const Brand = ({ dark = true, className = "", showText = true, iconOnly = false }) => {
  const src = dark ? LOGO_WHITE : LOGO_NAVY;
  const textColor = dark ? "#ffffff" : NAVY;
  return (
    <span className={`inline-flex items-center gap-[0.42em] align-middle ${className}`} data-testid="brand-wordmark">
      <img
        src={src}
        alt={showText && !iconOnly ? "" : "JOBTIMEHR"}
        aria-hidden={showText && !iconOnly ? "true" : undefined}
        draggable={false}
        className="shrink-0 w-auto select-none"
        style={{ height: "1.55em" }}
      />
      {showText && !iconOnly && (
        <span
          className="font-black leading-none whitespace-nowrap"
          style={{ letterSpacing: "-0.01em" }}
        >
          <span style={{ color: textColor }}>JOB</span>
          <span style={{ color: ORANGE }}>TIME</span>
          <span style={{ color: textColor }}>HR</span>
        </span>
      )}
    </span>
  );
};

export default Brand;
